<template>
    <div class="input-number">
        <button @click='sub' :class="{'disabled':num==min}">
            <span class="el-icon-minus"></span>
        </button><input :value="num" onkeyup="this.value=this.value.replace(/^(0+)|[^\d]+/g,'1')" class="number" type='text' :min='min' :max='max' @change='changeNum'/>
        <button @click='add' :class="{'disabled':num==max}">
            <span class="el-icon-plus"></span>
        </button>
    </div>
</template>
<script>
export default{
    name:'inputnumber',
    model: {
        prop: 'num',
        event: 'change'
    },
    props: {
        min:Number,
        max:Number,
        num:Number
    },
    methods: {
        changeNum(event){
            if(event.target.value==''){
                event.target.value=this.min
            }
            var newNum = parseInt(event.target.value);
            if(newNum>this.max){
                newNum=this.max
            }
            if(newNum<this.min||newNum==NaN){
                newNum=this.min
            }
            this.$emit('change',newNum)
        },
        add(){
            var newNum = this.num+1
            if(newNum>this.max){
                newNum=this.max
            }
            this.$emit('change',newNum)
        },
        sub(){
            var newNum = this.num-1
            if(newNum<this.min){
                newNum=this.min
            }
            this.$emit('change',newNum)
        }
    }
}
</script>
<style lang="less" scoped>
*{
    padding: 0;
    margin: 0;
    border:none;
}
.disabled{
    color:#CFCFCF !important;
    border:1px solid #dbdbdb !important;
}
.input-number{
    width: 180px;
    height:40px;
    font-size:0px;
          display: flex;
    justify-content: center;
    align-items: center;

    button{
       width: 26px;
height: 26px;

border: 1px solid #b9b9b9;
background: #fff;
        .el-icon-minus,.el-icon-plus{
            // font-weight:bold;
        }
    }
    buttom:first{
border-radius: 2px 0px 0px 2px;
    }
     buttom:last-child{
border-radius: 0px 2px 2px 0px;
    }
    .number{
       width: 38px;
        height: 26px;box-sizing: border-box;
        border-top:1px solid #B9B9B9;
        border-bottom:1px solid #B9B9B9;

        text-align:center;
        color:#323232;
    }
}

</style>



// WEBPACK FOOTER //
// src/common/inputnumber.vue